import { useEffect, useRef } from "react";
import axios from 'axios';
import EventEmitter from './emmiter';


export async function useracc ( redirect = 0 ) {
	return new Promise(async(resolve, reject) => {
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
			},
			withCredentials: true
		};
		try {
			const params = new URLSearchParams();
			let timeZone = '';
			try {
				timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
			} catch(error){}
			params.append( 'Timezone', timeZone );
			const z = await axios.post(`/v3/account/account`, params, config, { withCredentials: true } );
			if( z.status !== 200 ) {
				//window.location.href = "/login";
				return;
			}
			resolve( z.data );
		} catch( error ) {
			//window.location.href = "/login";
			return;
		}
	});
}


export async function userPerms(uid, user, admin = 0) {
	return new Promise((resolve, reject) => {
		if( user.admin ) {
			if( user.admin.admin_access === 1 && admin === 1 ) resolve(true);
			if( user.admin.mod_access === 1 ) resolve(true);
		}
		if( user.user.uid === uid ) resolve(true);
		return resolve(false);
	});
}


export async function postApi( url, params ) {
	return new Promise(async (resolve, reject) => {
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
			},
			withCredentials: true
		};
		const offset = new Date().getTimezoneOffset();
		params.append( 'Date', offset );
		axios.post(url, params, config )
		.then(res => {
			EventEmitter.emit('/syncerror', {show: false});
			resolve (res);
		})
		.catch(error => {
			if (error.message === "Network Error"){
				EventEmitter.emit('/syncerror', {show: true});
				setTimeout(_ => {
        	resolve(postApi(url,params));
      	}, 5000);
			} else {
				resolve(error);
			}
		});
	});
}


export async function putApi( url, params ) {
	return new Promise(async (resolve, reject) => {
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
			},
			withCredentials: true
		};
		params.append( 'Date', Date() );
		axios.put(url, params, config )
		.then(res => {
			EventEmitter.emit('/syncerror', {show: false});
			resolve (res);
		})
		.catch(error => {
			if (error.message === "Network Error"){
				EventEmitter.emit('/syncerror', {show: true});
				setTimeout(_ => {
        	resolve(putApi(url,params));
      	}, 5000);
			} else {
				resolve(error);
			}
		});
	});
}


export async function deleteApi( url, params ) {
	return new Promise(async (resolve, reject) => {
		params.append( 'Date', Date() );
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
			},
			withCredentials: true,
			data: params
		};
		axios.delete(url, config )
		.then(res => {
			EventEmitter.emit('/syncerror', {show: false});
			resolve (res);
		})
		.catch(error => {
			if (error.message === "Network Error"){
				EventEmitter.emit('/syncerror', {show: true});
				setTimeout(_ => {
        	resolve(deleteApi(url, params));
      	}, 5000);
			} else {
				resolve(error);
			}
		});
	});
}

export async function reportImage( url ) {
	try {
		const params = new URLSearchParams();
		params.append('Date', Date());
		params.append('image', url.target.src);
		const z = await axios.post(`/v3/report/image`, params, { withCredentials: true } );
	} catch(error) {}
}


export function timeAgo(time) {
	if( time === -1 ) return( <>Not yet played!</>);
	let _return = '';
	_return = Math.floor(time/60).toString() + " mins";
	if( time >= 60*60 ) _return = Math.floor(time/60/60).toString() + " hour" + (Math.floor(time/60)>1?"s":"");
	if( time >= 1440*60 ) _return = Math.floor(time/1440/60).toString() + " day" + (Math.floor(time/1440)>1?"s":"");
	return( <>{_return}</> );
}


export function bytesToSize(bytes) {
	const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB'];
	if (bytes === 0) return '0.00 KB';
	const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
	if (i === 0) return `${bytes} ${sizes[i]}`;
	return `${(bytes / (1024 ** i)).toFixed(2)} ${sizes[i]}`;
}


export function useInterval(callback, delay) {
  const savedCallback = useRef();

  // Remember the latest function.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}

export function dateUTCShedule(date, year = -1, month = -1, day = -1) {
	let _date = new Date(date);
	if( year !== -1 ) _date.setFullYear(year);
	if( month !== -1 ) _date.setMonth(month);
	if( day !== -1 ) _date.setDate(day);
	_date.setHours(0);
	_date.setMinutes(0);
	_date.setSeconds(0);
	return new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), 0, 0, 0));
}

export function dateUTC(date) {
	let _date = new Date(date);
	return new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds()));
}

export function dateLocal(utc) {
	let date = new Date(utc);
	return Math.floor(date.getTime()/1000);
}